<script>
  export default {
    data() {
      return {
        checkAll: false,
        checkAllRow: false
      }
    },
    methods: {
      changeCheck({sources=null, checkAll=null, checkAllRow=null } = {}) {
        let value = null

        if (checkAll !== null) {
          value = checkAll
          this.checkAll = value
          this.checkAllRow = value
        } else if (checkAllRow !== null) {
          value = checkAllRow
          this.checkAllRow = value
          if (!value) this.checkAll = value
        }

        if (value !== null && Array.isArray(sources)) {
          sources.forEach(s => {
            if ('checked' in s)
              s.checked = value
            else
              this.$set(s, 'checked', value)
          })
        } else if (sources && Array.isArray(sources)) {
          if (!sources.every(s => s.checked)) {
            this.checkAllRow = false
            this.checkAll = false
          }
        }
      }
    },
    name: 'CheckedModels'
  }
</script>

<style scoped>

</style>
